import { useMediaQuery } from "react-responsive"
import parse from "html-react-parser";

const MainGrayList = (props) => {

    const isMobile = useMediaQuery({ maxWidth: 1280 })
    const { title, itemArray } = props

    if (isMobile)
        return (
            <section className="flex w100 white-bkg gap-20">
                <section className="main-middle-section-mobile col gap-20">
                    <h2 className="middle-section-title ">{title}</h2>
                    {
                        (itemArray.map((item, index) => {
                            return (
                                <article key={index} className="main-li">
                                    <span className="main-li-icon-wrap"><i className={item.icon}></i></span>
                                    {parse(item.text)}
                                </article>
                            )
                        }))
                    }
                </section>
            </section>
        )
    else
        return (
            <section className="flex col gap-20">
                <section className="main-middle-section-2">
                    <h2 className="middle-section-title ">{title}</h2>
                </section>
                <ul className="main-ul flex col gap-20">
                    {
                        (itemArray.map((item, index) => {
                            return (
                                <li key={index} className="main-li">
                                    <span className="main-li-icon-wrap"><i className={item.icon}></i></span>
                                    {parse(item.text)}
                                </li>
                            )
                        }))
                    }
                </ul>
            </section>
        )

}

export default MainGrayList